import { inlinedQrl } from "@builder.io/qwik";
function useCollapsible() {
  const getHiddenHeight = /* @__PURE__ */ inlinedQrl((el) => {
    const clone = el.cloneNode(true);
    Object.assign(clone.style, {
      overflow: "visible",
      height: "auto",
      maxHeight: "none",
      opacity: "0",
      visibility: "hidden",
      display: "block"
    });
    el.after(clone);
    const height = clone.offsetHeight;
    clone.remove();
    return height;
  }, "useCollapsible_getHiddenHeight_t8e7MxyQ9Kk");
  return {
    getHiddenHeight
  };
}
export {
  useCollapsible
};
